import {
  accept,
  base,
  createFetch,
  createStack,
  header,
  init,
  json,
  method,
  params,
} from 'http-client';
import * as Cookies from 'js-cookie';

import { DEPLOY_TYPE } from '../helpers/globals';

const COOKIE_KEY = DEPLOY_TYPE ? 'XSRF-G-TOKEN' : 'XSRF-TOKEN';
const baseUrl = '/external_tooling/v1';
const commonStack = createStack(
  init('credentials', 'include'),
  accept('application/json'),
  header('Content-Type', 'application/json'),
  header('X-CSRF-Token', Cookies.get(COOKIE_KEY)),
);

function doApiGet(url: string, getParams?: object): Promise<Response> {
  let stack = createStack(commonStack, base(baseUrl));
  if (getParams) {
    stack = createStack(stack, params(getParams));
  }
  return createFetch(stack)(url);
}

function doApiPost(url: string, jsonParams: object): Promise<Response> {
  return createFetch(commonStack, method('POST'), base(baseUrl), json(jsonParams))(url);
}

export async function fetchOffer(token: string) {
  return doApiGet(`/compose_offer/offer_email`, { token }).then(res => res.json());
}

export function sendEmail(token: string, message: string) {
  return doApiPost(`/compose_offer/send_offer_email`, { token, message });
}
